import { createSlice } from "@reduxjs/toolkit";

export const  comRegionSlice = createSlice({
    name : "ComRegion",
    initialState: {
        coderegion: ""        
    },
    reducers : {
        sendCodeRegion : (state, action) =>{
            state.coderegion = action.payload 
        }
    }
})